import React from "react";
import {Box, Button, ButtonGroup, Icon, Modal, Spinner, Tag, Text} from "@nike/eds";
import {edsSpace16} from "@nike/eds/dist/tokens";

interface ManualClearingInventoryFoundModalProps {
    isOpen: boolean;
    onDismiss: () => void;
    onConfirm: () => void;
    eligibleDocumentIds: string[];
    noInventoryDocumentIds: string[];
    totalBondedUnits: number;
    reason: string;
    comment: string;
    processing: boolean;
}

function ManualClearingInventoryFoundModal({
                                               isOpen,
                                               onDismiss,
                                               onConfirm,
                                               noInventoryDocumentIds,
                                               totalBondedUnits,
                                               processing,
                                           }: ManualClearingInventoryFoundModalProps) {

    const footer = processing ? (
        <Spinner size="medium"/>
    ) : (
        <ButtonGroup>
            <Button variant="primary" onClick={onConfirm}>Confirm</Button>
            <Button variant="secondary" onClick={onDismiss}>Cancel</Button>
        </ButtonGroup>
    );

    return (
        <Modal
            isOpen={isOpen}
            onDismiss={onDismiss}
            headerSlot="Confirm manual clearing"
            footerSlot={footer}
        >
            <Box>
                <Text>
                    <strong> Amount of units currently present in inventory: {totalBondedUnits}</strong>
                </Text>
                {noInventoryDocumentIds.length > 0 && (
                    <Text style={{marginTop: edsSpace16}}>
                        The following Document ID{noInventoryDocumentIds.length !== 1 ? "s have" : " has"} <strong>no
                        remaining inventory</strong> and will be ignored:
                        <br/>
                        {noInventoryDocumentIds.map((value) => (<><Tag color="orange" style={{marginTop: "5px"}}> <Icon
                            name="Close" size="s" color={"red"} style={{verticalAlign: "middle"}}/> {value}</Tag>
                            <br/></>))}
                    </Text>
                )}
                <br/>
                <Text><i>Do note that this is the current estimate, since transcations are continuously impacting the CI
                    quantities.</i></Text>
                <br/>
                <Text>Are you sure you want to clear all these units?</Text>
            </Box>
        </Modal>
    );
}

export default ManualClearingInventoryFoundModal;
